import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Comptabilite from "@/pages/Comptabilite";
import Fiscalite from "@/pages/Fiscalite";
import Tva from "@/pages/Tva";
import SalairesRh from "@/pages/SalairesRh";
import AdministrateurGerant from "@/pages/AdministrateurGerant";
import CreationSociete from "@/pages/CreationSociete";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/comptabilite" element={<Comptabilite />} />
                        <Route path="/fiscalite" element={<Fiscalite />} />
                        <Route path="/tva" element={<Tva />} />
                        <Route path="/salaires-rh" element={<SalairesRh />} />
                        <Route path="/administrateur-gerant" element={<AdministrateurGerant />} />
                        <Route path="/creation-societe" element={<CreationSociete />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/mentions-legales" element={<MentionsLegales />} />
                        <Route
                            path="/politique-confidentialite"
                            element={<PolitiqueConfidentialite />}
                        />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
